import React from 'react'
import ExhibitorCard from './ExhibitorCard'
import { onlyType } from '../../functions/exhibitorViews'
import { LABELS } from '../../constants/staticText'

// Praktikumsplätze und (Duale) Studiengänge sind dieselbe Menge, über den
// Angebotstyp gefiltert (Spec Abschnitt 4.3/9).
const TypeFilteredExhibitors = ({ data, types, themesPath, LinkComponent }) => {
    const exhibitors = onlyType(data, types)

    if (0 === exhibitors.length) return <p className="section-empty">{LABELS.noExhibitors}</p>

    return (
        <div className="exhibitor-cards">
            {exhibitors.map(exhibitor => (
                <ExhibitorCard key={exhibitor.participantId} exhibitor={exhibitor} themesPath={themesPath} LinkComponent={LinkComponent} />
            ))}
        </div>
    )
}

export default TypeFilteredExhibitors
